import styled from 'styled-components'
import { Flex } from 'grid-styled'
import theme from '../../theme'

export const Wrapper = styled(Flex)`
  flex-direction: column;
  height: 100vh;
  width: 100vw;
`

export const Background = styled(Flex)`
  width: 0;
  height: 0;
  border-bottom: 100vh solid ${theme.colors.black};
  border-left: 100vw solid ${theme.colors.white};
  align-items: flex-end;
  justify-content: flex-end;
  &:hover {
    background-color: pink;
  }
`

export const BlackHalf = styled(Flex)`
  height: 50%;
  width: 100%;
  background-color: ${theme.colors.black};
`

export const BlackLabel = styled(Flex)`
  font-family: ${theme.fonts.splash.family};
  letter-spacing: 6px;
  font-weight: bold;
  font-size: 18vh;
  line-height: 0.7;
  color: ${({ color }) => color};
  transform-origin: center;
  backface-visibility: hidden;
  position: fixed;
  z-index: 10;
  -webkit-backface-visibility: hidden;
  transform: translate(50vw, 50vh) translate(-50%, -50%)
    ${({ angle }) => `rotate(-${angle}deg)`};
  white-space: pre-wrap;
  cursor: default;
  font-style: italic;
  // font-size: 92px;
  // line-height: 62px;
`

export const WhiteLabel = styled(Flex)`
  font-family: ${theme.fonts.splash.family};
  letter-spacing: 6px;
  font-weight: bold;
  font-size: 18vh;
  line-height: 0.74;
  color: ${({ color }) => color};
  transform-origin: center;
  position: fixed;
  z-index: 10;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform: translate(50vw, 50vh) translate(-50%, -50%)
    ${({ angle }) => `rotate(-${angle}deg)`};
  white-space: pre-wrap;
  cursor: default;
  font-style: italic;
  // font-size: 92px;
  // line-height: 67.99px;
`

export const WhiteRect = styled(Flex)`
  width: 100vw;
  height: 50vh;
  background-color: ${theme.colors.white};
  color: ${theme.colors.black};
  &:hover {
    color: ${theme.colors.palePurple};
  }
  font-family: ${theme.fonts.splash.family};
  font-size: 14vh;
  justify-content: center;
  align-items: center;
  cursor: default;
`

export const BlackRect = styled(Flex)`
  width: 100vw;
  height: 50vh;
  background-color: ${theme.colors.black};
  color: ${theme.colors.white};
  &:hover {
    color: #a4a9c4;
  }
  font-family: ${theme.fonts.splash.family};
  font-size: 14vh;
  justify-content: center;
  align-items: center;
  cursor: default;
`



// WEBPACK FOOTER //
// ./src/containers/Home/styles.js